import React from "react"
import { graphql } from "gatsby"
import { Content } from "components/content/Content"
import { useLogos } from "hooks/queries/settings/useLogos"
import { Image } from "components/image/Image"
import { CouponProps } from "./coupons"
import { ButtonParser } from "components/button/ButtonParser"
import { ButtonElements } from "_types/Button"

export const Coupon = ({
  id,
  coupon_value,
  sub_heading,
  description,
  button_text,
  associated_page,
  migrated_associated_page,
  anchor_reference,
  custom_anchor_reference,
  external_link,
  disclaimer,
  offer_end_date,
  hide_logo = false,
}: CouponProps) => {
  const { headerLogo } = useLogos()

  const anchorReference = custom_anchor_reference || anchor_reference

  const button: ButtonElements = {
    anchor_reference,
    associated_page,
    button_style: anchorReference ? "cta button" : "navigation button",
    button_text,
    custom_anchor_reference,
    custom_call_tracking_number: "",
    external_link,
    id,
    migrated_associated_page,
    use_main_office_call_tracking_number: false,
  }

  return (
    <div className="coupon">
      <div className="coupon__header">
        {coupon_value && <h2 className="coupon__heading">{coupon_value}</h2>}
        {sub_heading && <h3 className="coupon__sub-heading">{sub_heading}</h3>}
        {description && <Content content={description.data.description} />}
      </div>
      <div className="coupon__footer">
        <ButtonParser
          buttons={[button]}
          extraClassNames="coupon__button"
          ctaColorVariantSolid="solid-accent"
          navigationColorVariantSolid="solid-accent"
        />

        {!hide_logo && <Image image={headerLogo} className="coupon__logo" />}
        {offer_end_date && (
          <p className="coupon__end-date">Offer Ends: {offer_end_date}</p>
        )}
        {disclaimer && <p className="coupon__disclaimer">*{disclaimer}</p>}
      </div>
    </div>
  )
}

export const query = graphql`
  fragment StrapiCouponFragment on STRAPI_COUPON {
    id
    coupon_list {
      coupon_value
      sub_heading
      description {
        data {
          description
        }
      }
      button_text
      migrated_associated_page
      anchor_reference
      custom_anchor_reference
      external_link
      associated_page {
        slug
      }
      hide_logo
      offer_end_date
      disclaimer
    }
  }
`
